import { React } from "react";
import CsData from "./extra_data/CsData";
import BatteryChargingSummary from "./extra_data/BatteryChargingSummary";
import EventData from "./extra_data/EventData";
import EventSummary from "./extra_data/EventSummary";

const ShowSummaryData = (props) => {
  const { csDiagnostics, setIsLoading } = props;

  return <div className="row g-3 mb-4">
    <div className="d-flex justify-content-center alin-item-center">
      <h6 className="text-success">DETAILED SUMMARY</h6>
    </div>
    <div className="col-md-6">
      <CsData csDiagnosticsParams={csDiagnostics} setIsLoading={setIsLoading} />
    </div>
    <div className="col-md-6">
      <BatteryChargingSummary csDiagnosticsParams={csDiagnostics} setIsLoading={setIsLoading} />
    </div>
    <div className="col-md-6">
      <EventData csDiagnosticsParams={csDiagnostics} setIsLoading={setIsLoading} />
    </div>
    <div className="col-md-6">
      <EventSummary csDiagnosticsParams={csDiagnostics} setIsLoading={setIsLoading} />
    </div>
  </div>
}

export default ShowSummaryData;
